export function normalize(value = '') {
  return value.replace(/^(\d{2})0(\d+)$/, '$1$2');
}
